export default __webpack_public_path__ + "static/media/digital-ready-infrastructure.7b2195ec.svg";